import PropTypes from 'prop-types';
import StatisticsPanelSection from '../../components/StatisticsPanelSection';
import AdvancedStatistics from '../../components/StatisticsPanelSection/AdvancedStatistics';
import MultipleHydrobasinsAttribute from '../MultipleHydrobasinsAttribute';
import MultipleHydrobasinsCharts from '../MultipleHydrobasinsCharts';

import './style.scss';
import SwcAttribute from '../../components/SwcAttribute';

const MultipleHydrobasinsStatistics = ({sections}) => {
	return (
		<>
			{sections.map(section => {
				const {key, title, attributes, charts, layers} = section;
				const advancedStatistics =
					charts || layers ? (
						<AdvancedStatistics>
							{/*{layers?.length ? <StatisticsLayers layers={layers} /> : null}*/}
							{charts ? <MultipleHydrobasinsCharts charts={charts} /> : null}
						</AdvancedStatistics>
					) : null;

				return (
					<StatisticsPanelSection
						key={key}
						sectionKey={key}
						heading={title}
						AdvancedStatistics={advancedStatistics}
					>
						{attributes.map(attribute => {
							return (
								<MultipleHydrobasinsAttribute
									key={attribute}
									attributeKey={attribute}
								/>
							);
						})}
						{key === 'surface-water-changes' ? (
							<>
								<SwcAttribute
									attributeMetadata={{
										data: {nameDisplay: 'Gain water - max', unit: 'sqkm'},
									}}
									attributeKey="swcmaxA"
									attributeLatestKey="swcmaxB"
									type="gain"
									store="basin"
								/>
								<SwcAttribute
									attributeMetadata={{
										data: {nameDisplay: 'Gain water - min', unit: 'sqkm'},
									}}
									attributeKey="swcminA"
									attributeLatestKey="swcminB"
									type="gain"
									store="basin"
								/>
								<SwcAttribute
									attributeMetadata={{
										data: {nameDisplay: 'Loss water - max', unit: 'sqkm'},
									}}
									attributeKey="swcmaxA"
									attributeLatestKey="swcmaxB"
									type="loss"
									store="basin"
								/>
								<SwcAttribute
									attributeMetadata={{
										data: {nameDisplay: 'Loss water - min', unit: 'sqkm'},
									}}
									attributeKey="swcminA"
									attributeLatestKey="swcminB"
									type="loss"
									store="basin"
								/>
							</>
						) : null}
					</StatisticsPanelSection>
				);
			})}
		</>
	);
};

MultipleHydrobasinsStatistics.propTypes = {
	sections: PropTypes.array,
};

export default MultipleHydrobasinsStatistics;
